export const localeKeyMap = {
  suiteName: "suiteName",
  verticalName: "verticalName",
  name: "name",
  tenantID: "tenantID",
  headquarterAddress: "headquarterAddress",
  country: "country",
  region: "region",
  state: "state",
  streetAddress: "streetAddress",
  city: "city",
  zipCode: "zipCode",
  latitude: "latitude",
  longitude: "longitude",
  status: "status",
  currency: "currency",
  products: "products",
  dataCenter: "dataCenter",
  timeZone: "timeZone",
  createdOn: "createdOn",
  userList: "userList",
  users: "users",
  search: "search",
  createNewUser: "createNewUser",
  noFiltersApplied: "noFiltersApplied",
  emailId: "emailId",
  roles: "roles",
  organisation: "organisation",
  sso: "sso",
  action: "action",
  profileInformation: "profileInformation",
  enableSSO: "enableSSO",
  firstName: "firstName",
  lastName: "lastName",
  phoneNumber: "phoneNumber",
  enterPhoneNumber: "enterPhoneNumber",
  assignOrganization: "assignOrganization",
  assignRole: "assignRole",
  identityProvider: "identityProvider",
  enter: "enter",
  enterEmailId: "enterEmailId",
  enterFirstName: "enterFirstName",
  selectCode: "selectCode",
  selectAnOption: "selectAnOption",
  selectIP: "selectIP",
  addPhoto: "addPhoto",
  cancel: "cancel",
  create: "create",
  userProfile: "userProfile",
  addUser: "addUser",
  acceptTerms: "acceptTerms",
  selectOrganizations: "selectOrganizations",
  pleaseAssignOrganization: "pleaseAssignOrganization",
  removeChip: "removeChip",
  pleaseSelectRoles: "pleaseSelectRoles",
  pleaseAssignIdentityProvider: "pleaseAssignIdentityProvider",
  createUser: "createUser",
  confirmCreateUser: "confirmCreateUser",
  userCreationSuccess: "userCreationSuccess",
  userAccountCreated: "userAccountCreated",
  userConsentAgreement: "userConsentAgreement",
  basicInformation: "basicInformation",
  otherInformation: "otherInformation",
  moreInfo: "moreInfo",
  more: "more",
  edit: "edit",
  delete: "delete",
  success: "success",
  deactivateUser: "deactivateUser",
  activateUser: "activateUser",
  resetPassword: "resetPassword",
  resetPasswordConfirmation: "resetPasswordConfirmation",
  passwordResetSuccessfully: "passwordResetSuccessfully",
  youAreChangingUserStatusOf: "youAreChangingUserStatusOf",
  fromActiveToInactive: "fromActiveToInactive",
  fromInactiveToActive: "fromInactiveToActive",
  doYouWantToProceed: "doYouWantToProceed",
  deactivatedSuccessfully: "deactivatedSuccessfully",
  activatedSuccessfully: "activatedSuccessfully",
  userStatusChangedToInactive: "userStatusChangedToInactive",
  userStatusChangedToActive: "userStatusChangedToActive",
  publish: "publish",
  publishTooltip: "publishTooltip",
  generateCertificate: "generateCertificate",
  refresh: "refresh",
  downloadExcel: "downloadExcel",
  deleteSingleUser: "deleteSingleUser",
  deleteMultipleUsers: "deleteMultipleUsers",
  pleaseConfirm: "pleaseConfirm",
  deleteUnsuccessful: "deleteUnsuccessful",
  noPermissionDeleteSelected: "noPermissionDeleteSelected",
  successfullyDeleted: "successfullyDeleted",
  userDeletedSuccessfully: "userDeletedSuccessfully",
  filter: "filter",
  close: "close",
  filterBy: "filterBy",
  clearAll: "clearAll",
  organizations: "organizations",
  showResults: "showResults",
  emailPlaceholder: "emailPlaceholder",
  creationSuccess: "creationSuccess",
  selected: "selected",
  selectIdentityProvider: "selectIdentityProvider",
  phoneNumberHelperText: "phoneNumberHelperText",
  firstNameHelperTextEmpty: "firstNameHelperTextEmpty",
  firstNameHelperTextInvalid: "firstNameHelperTextInvalid",
  lastNameHelperTextEmpty: "lastNameHelperTextEmpty",
  lastNameHelperTextInvalid: "lastNameHelperTextInvalid",
  emailHelperTextEmpty: "emailHelperTextEmpty",
  emailHelperTextInvalid: "emailHelperTextInvalid",
  emailHelperTextConflict: "emailHelperTextConflict",
  home: "home",
  organization: "organization",
  user: "user",
  userInformation: "userInformation",
  assignedOrganization: "assignedOrganization",
  assignedRole: "assignedRole",
  deleteSuccessTitle: "deleteSuccessTitle",
  successDialogMessageDelete: "successDialogMessageDelete",
  deleteConfirmationMessage: "deleteConfirmationMessage",
  update: "update",
  updateUser: "updateUser",
  updateUserDialogContent: "updateUserDialogContent",
  updatingUser: "updatingUser",
  updatingUserInfoDialogContent: "updatingUserInfoDialogContent",
  editUserTitle: "editUserTitle",
  updatePhoto: "updatePhoto",
  organizationHelperTextEmpty: "organizationHelperTextEmpty",
  totalOneOrganization: "totalOneOrganization",
  totalManyOrganizations: "totalManyOrganizations",
  schedule: "schedule",
  noPrivilegesToCreateOrganization: "noPrivilegesToCreateOrganization",
  createNewOrganization: "createNewOrganization",
  totalUsers: "totalUsers",
  deleteOrganizationConfirmation: "deleteOrganizationConfirmation",
  organizationDeleteSuccess: "organizationDeleteSuccess",
  total: "total",
  parentName: "parentName",
  organizationInformation: "organizationInformation",
  noUsersAvailable: "noUsersAvailable",
  noOrganization: "noOrganization",
  noPrivilegesToCreateUsers: "noPrivilegesToCreateUsers",
  noPrivilegesToReadOrganizations: "noPrivilegesToReadOrganizations",
  noPrivilegesToDeleteOrganizations: "noPrivilegesToDeleteOrganizations",
  noPrivilegesToEditUsers: "noPrivilegesToEditUsers",
  noPrivilegesToDeleteUsers: "noPrivilegesToDeleteUsers",
  organizationUsers: "organizationUsers",
  organizationUserList: "organizationUserList",
  deleteUser: "deleteUser",
  removeChipWithContent: "removeChipWithContent",
  noPrivilegesToEditOrganizations: "noPrivilegesToEditOrganizations",
  deleteSuccessMessage: "deleteSuccessMessage",
  profileInformationTitle: "profileInformationTitle",
  tenantNameLabel: "tenantNameLabel",
  headquarterAddressLabel: "headquarterAddressLabel",
  addressHelperText: "addressHelperText",
  requiredField: "requiredField",
  tenantCurrencyLabel: "tenantCurrencyLabel",
  tenantDataCenterLabel: "tenantDataCenterLabel",
  tenantTimeZone: "tenantTimeZone",
  selectProductLabel: "selectProductLabel",
  selectUtilityTypeLabel: "selectUtilityTypeLabel",
  selectAll: "selectAll",
  editTenantTitle: "editTenantTitle",
  confirmUpdateTenant: "confirmUpdateTenant",
  selectRegionFirst: "selectRegionFirst",
  selectCountryFirst: "selectCountryFirst",
  cityHelperText: "cityHelperText",
  streetAddressHelperText: "streetAddressHelperText",
  zipcodeHelperText: "zipcodeHelperText",
  latitudeHelperText: "latitudeHelperText",
  longitudeHelperText: "longitudeHelperText",
  settingsInformation: "settingsInformation",
  setting: "setting",
  value: "value",
  moreInformation: "moreInformation",
  certificateGeneratedSuccessfully: "certificateGeneratedSuccessfully",
  signedCertificate: "signedCertificate",
  copy: "copy",
  copiedToClipboard: "copiedToClipboard",
  selectProduct: "selectProduct",
  selectAProduct: "selectAProduct",
  certificateSigningRequest: "certificateSigningRequest",
  validateCSR: "validateCSR",
  pleaseValidateCSR: "pleaseValidateCSR",
  submit: "submit",
  ok: "ok",
  editTenant: "editTenant",
  editSettings: "editSettings",
  enterTenantDetails: "enterTenantDetails",
  addParameters: "addParameters",
  summary: "summary",
  next: "next",
  back: "back",
  tenantUpdated: "tenantUpdated",
  tenantUpdatedMessage: "tenantUpdatedMessage",
  navigateToTenantPageClick: "navigateToTenantPageClick",
  toActivateTheChanges: "toActivateTheChanges",
  setupTenant: "setupTenant",
  summarySaveToContinue: "summarySaveToContinue",
  summaryTitle: "summaryTitle",
  summaryName: "summaryName",
  summaryTenantID: "summaryTenantID",
  summarySelectedProduct: "summarySelectedProduct",
  summaryBack: "summaryBack",
  summarySave: "summarySave",
  settingsSelectApplication: "settingsSelectApplication",
  settingsParametersTitle: "settingsParametersTitle",
  logoAltText: "logoAltText",
  tenantNameAlphaOnly: "tenantNameAlphaOnly",
  tenantNamePlaceholder: "tenantNamePlaceholder",
  tenantNameError: "tenantNameError",
  headquartersAddress: "headquartersAddress",
  productPlaceholder: "productPlaceholder",
  saveTenantConfirmation: "saveTenantConfirmation",
  confirm: "confirm",
  organizationProfile: "organizationProfile",
  addLogo: "addLogo",
  organizationName: "organizationName",
  organizationId: "organizationId",
  parentOrganizationName: "parentOrganizationName",
  selectParentOrganization: "selectParentOrganization",
  selectValidParentOrganization: "selectValidParentOrganization",
  acceptCreateOrganization: "acceptCreateOrganization",
  confirmCreateOrganization: "confirmCreateOrganization",
  successfullyCreated: "successfullyCreated",
  organizationCreated: "organizationCreated",
  pleaseEnterValidName: "pleaseEnterValidName",
  organizationNameAlphanumeric: "organizationNameAlphanumeric",
  noInformation: "noInformation",
  editOrganization: "editOrganization",
  updateLogo: "updateLogo",
  parentOrganizationNameRequired: "parentOrganizationNameRequired",
  selectValidParent: "selectValidParent",
  acceptUpdateOrganization: "acceptUpdateOrganization",
  updateOrganization: "updateOrganization",
  updateOrganizationConfirm: "updateOrganizationConfirm",
  successfullyUpdated: "successfullyUpdated",
  organizationUpdated: "organizationUpdated",
  noPrivilegesToReadTenantLogo: "noPrivilegesToReadTenantLogo",
  noPrivilegesToReadTenant: "noPrivilegesToReadTenant",
  noPrivilegesToListTenantUsers: "noPrivilegesToListTenantUsers",
  noPrivilegesToCreateTenantUsers: "noPrivilegesToCreateTenantUsers",
  datasheetFileName: "datasheetFileName",
  downloading: "downloading",
  remove: "remove",
  userCreationInProgress: "userCreationInProgress",
  userCreationInProgressDescription: "userCreationInProgressDescription",
  userUpdateInProgress: "userUpdateInProgress",
  userUpdateInProgressDescription: "userUpdateInProgressDescription",
  organizationCreationInProgress: "organizationCreationInProgress",
  organizationCreationInProgressDescription: "organizationCreationInProgressDescription",
  failedToLoadOrganizationTreeData: "failedToLoadOrganizationTreeData",
  organizationDetails: "organizationDetails",
  sessionTimeoutTitle: "sessionTimeoutTitle",
  sessionTimeoutMessage: "sessionTimeoutMessage",
  sessionTimeoutMinutesAndSeconds: "sessionTimeoutMinutesAndSeconds",
  sessionTimeoutSeconds: "sessionTimeoutSeconds",
  resume: "resume",
};